import { Component , OnInit , Input } from '@angular/core';
import { FAQ } from 'src/app/classes/interfaces/faq-interfce';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-acordian',
  templateUrl: './acordian.component.html',
  styleUrls: ['./acordian.component.scss']
})
export class AcordianComponent implements OnInit {
  loading = false;
  multi = false;
  @Input() faq: FAQ[];

  ngOnInit() {
    if (AppComponent.isBrowser.value){
      this.loading = true;
    }
  }

  toggle(index: number) {
    if (!this.multi) {
      this.faq.filter(
        (faq, i) => i !== index && faq.active
      );
    }
    this.faq[index].active = !this.faq[index].active;
  }

}
